import { render, staticRenderFns } from "./MapaDeSala.vue?vue&type=template&id=5dbd77e0&scoped=true&"
import script from "./MapaDeSala.vue?vue&type=script&lang=js&"
export * from "./MapaDeSala.vue?vue&type=script&lang=js&"
import style0 from "./MapaDeSala.vue?vue&type=style&index=0&id=5dbd77e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd77e0",
  null
  
)

export default component.exports